import { render, staticRenderFns } from "./newTeachingMaterialEdit.vue?vue&type=template&id=75b1b1fe&scoped=true"
import script from "./newTeachingMaterialEdit.vue?vue&type=script&lang=js"
export * from "./newTeachingMaterialEdit.vue?vue&type=script&lang=js"
import style0 from "./newTeachingMaterialEdit.vue?vue&type=style&index=0&id=75b1b1fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b1b1fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b1b1fe')) {
      api.createRecord('75b1b1fe', component.options)
    } else {
      api.reload('75b1b1fe', component.options)
    }
    module.hot.accept("./newTeachingMaterialEdit.vue?vue&type=template&id=75b1b1fe&scoped=true", function () {
      api.rerender('75b1b1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/newTeachingMaterial/newTeachingMaterialEdit.vue"
export default component.exports